interface ExodusMarkProps {
  className?: string
  size?: number
}

export function ExodusMark({ className }: ExodusMarkProps) {
  return (
    <svg
      width="198"
      height="40"
      viewBox="0 0 198 40"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1031_2)">
        <path d="M74.5311 14.497V11H54.0388V29H74.5311V25.503H58.2225V21.5723H72.0795V18.0753H58.2225V14.497H74.5311Z" />
        <path d="M86.214 19.8915L76.8442 29H82.4183L89.293 22.3855L95.3183 29H101.131L91.7615 19.8915L100.839 11H95.451L89.293 17.4247L82.8695 11H77.1096L86.214 19.8915Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.367 11C119.958 11 124.524 14.7565 124.524 20C124.524 25.2434 119.958 29 112.367 29C104.776 29 100.236 25.2434 100.236 20C100.236 14.7565 104.776 11 112.367 11ZM112.367 14.3652C107.802 14.3652 104.436 16.6348 104.436 20C104.436 23.3652 107.802 25.6347 112.367 25.6347C116.958 25.6347 120.323 23.3652 120.323 20C120.323 16.6348 116.958 14.3652 112.367 14.3652Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M149.4 19.9729C149.4 14.3343 145.736 11 139.656 11H127.389V29H139.709C145.762 29 149.4 25.6656 149.4 19.9729ZM139.125 14.497C142.974 14.497 145.098 16.4488 145.098 19.9729C145.098 23.5241 142.974 25.503 139.125 25.503H131.558V14.497H139.125Z"
        />
        <path d="M163.186 29C156.784 29 151.928 26.1285 151.928 20.8375V11H156.117V20.4387C156.117 23.709 159.558 25.2245 163.186 25.2245C166.841 25.2245 170.283 23.7356 170.283 20.4387V11H174.445V20.8375C174.445 26.1285 169.616 29 163.186 29Z" />
        <path d="M176.388 27.2C179.021 28.3739 182.729 29 186.169 29C192.35 29 197.133 26.9913 197.133 23.3913C197.133 20.5478 194.876 19.0869 190.522 18.4869L184.825 17.8608C182.407 17.5217 181.466 17.1043 181.466 16.2695C181.466 15.0695 183.347 14.4174 186.196 14.4174C188.964 14.4174 192.887 14.8869 195.198 15.8261L196.569 12.6434C194.231 11.6 189.689 11 186.384 11C180.902 11 177.167 13.0608 177.167 16.5565C177.167 19.2695 179.37 20.8087 183.885 21.4087L189.743 22.0347C191.812 22.3478 192.806 22.7391 192.806 23.6521C192.806 24.9043 189.662 25.6087 186.303 25.6087C183.374 25.6087 180.123 24.9304 177.758 23.8608L176.388 27.2Z" />
        <path
          d="M17.7224 22.587H8.00138L6.70043 26.6548L17.7586 33.7556V40L0.484741 28.8671L3.30348 20.0178L0.484741 11.1686L17.7224 0V6.24442L6.70043 13.3452L7.96525 17.413H17.7224V22.587Z"
          fill="url(#paint0_linear_1031_2)"
        />
        <path
          d="M22.9985 0L40.2362 11.1686L37.4175 20.0178L40.2362 28.8671L22.9985 40V33.7556L34.0567 26.6548L32.7557 22.587H22.9985V17.413H32.7557L34.0567 13.3452L22.9985 6.24442V0Z"
          fill="url(#paint1_linear_1031_2)"
        />
        <path
          d="M8.00138 22.587H17.7224V17.413H7.96525L6.70043 13.3452L17.7224 6.24442V3.05176e-05L0.505981 11.1548V11.2353L3.30348 20.0178L0.505981 28.8004V28.8808L17.7586 40V33.7556L6.70043 26.6548L8.00138 22.587Z"
          fill="url(#paint2_linear_1031_2)"
        />
        <path
          d="M39.9727 28.0398V29.0373L22.9985 40V33.7556L34.0567 26.6548L32.7557 22.587H22.9985V17.413H32.7557L34.0567 13.3452L22.9985 6.24442V3.05176e-05L39.9727 10.9979V11.9959L37.4175 20.0178L39.9727 28.0398Z"
          fill="url(#paint3_linear_1031_2)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1031_2"
          x1="34.6598"
          y1="42.75"
          x2="23.37"
          y2="-4.45419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B46F9" />
          <stop offset="1" stopColor="#BBFBE0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1031_2"
          x1="34.6598"
          y1="42.75"
          x2="23.37"
          y2="-4.45419"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B46F9" />
          <stop offset="1" stopColor="#BBFBE0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1031_2"
          x1="3.0359"
          y1="9.00003"
          x2="22.8514"
          y2="23.976"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#8952FF" stopOpacity="0.87" />
          <stop offset="1" stopColor="#DABDFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1031_2"
          x1="3.0359"
          y1="9.00003"
          x2="22.8514"
          y2="23.976"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#8952FF" stopOpacity="0.87" />
          <stop offset="1" stopColor="#DABDFF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_1031_2">
          <rect width="198" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
